export default {
  "buttons": {
    "readMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beitrag lesen"])},
    "loadMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weitere Beiträge anzeigen"])}
  },
  "pagination": {
    "of": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["von"])},
    "loaded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beiträgen geladen"])}
  }
}